import { ValueOf } from '../types';

export const SLICE_LAYER_TYPES = {
  range: 'Range',
  singleLayer: 'SingleLayer',
} as const;

export type TSliceLayerTypes = ValueOf<typeof SLICE_LAYER_TYPES>;
